const VoteStages = {
  ENTER_USERNAME: 0,
  VOTE_ON_SITES: 1,
};

export default Object.freeze(VoteStages);
